
import { defineComponent, ref, reactive, nextTick } from 'vue'
import { useRouter, useRoute, onBeforeRouteUpdate } from 'vue-router'
import $bus from '@/utils/bus'
export default defineComponent({
    setup() {
        const router = useRouter()
        const route = useRoute()
        const activateNav = ref(route.path)
        const activateNav1 = ref(false)
        const activateNav2 = ref(false)
        const navs = reactive([
            { name: '首页', value: 0, path: '/index' },
            { name: '精准获客', value: 1, path: '/index' },
            { name: '运营系统', value: 2, path: '/index' },
            { name: '成功案例', value: 3, path: '/case' },
            { name: '联系我们', value: 4, path: '/contact' }
        ])
        function onNavClick(value: number) {
            router.replace({ path: navs[value].path })
            activateNav1.value = value == 1
            activateNav2.value = value == 2

            if(value == 1) {$bus.emit('GOANCHOR', 'customer')}
            if(value == 2) {$bus.emit('GOANCHOR', 'operation')}
        }
        onBeforeRouteUpdate(to => {
            activateNav.value = to.path
            if (to.path !== '/index') {
                nextTick(() => {
                    (document.querySelector('#pageContent') as HTMLElement).scrollIntoView({
                        behavior: 'smooth'
                    });
                })
            }
        })
        function consult() {
            $bus.emit('CONSULT_POPUP', true)
        }
        return {
            navs,
            activateNav,
            onNavClick,
            consult,
            activateNav1,
            activateNav2
        }
    }
})
